export const HISTORY = [
  {
    version: '2019.05.1',
    date: '2019.05.10',
    info: [
      'Bug fix'
    ]
  }, {
    version: '2019.05.1',
    date: '2019.05.01',
    info: [
      'QbatesApp released to Google Play Store'
    ]
  }
];


// WEBPACK FOOTER //
// ./src/utils/android_update_history.js